<template>
  <div class="templates">
    <div class="templates__list" v-if="filteredTemplates.length">
      <div class="templates__select-all mb-2 pb-3">
        <v-checkbox
          :inputValue="isSelectedAll"
          hide-details
          :label="$t('message.common.selectAll')"
          @click.prevent="toggleAll"
        />
        <ItemsCounter :count="selectedIds.length" />
      </div>
      <div
        class="templates__list-item"
        v-for="template in filteredTemplates"
        :key="template.id"
        @click="toggleItem(template)"
      >
        <v-checkbox
          :inputValue="isSelected(template)"
          @click.prevent=""
          hide-details
        ></v-checkbox>
        <div class="templates__text">{{ template.text }}</div>
      </div>
    </div>
    <div class="templates__no-data" v-else>
      {{ $t("message.reviews.replyTemplates.templates.noTemplates") }}
    </div>
  </div>
</template>

<script>
import ItemsCounter from "@/components/List/ItemsCounter";

export default {
  name: "BulkReplyTemplates",
  components: {
    ItemsCounter
  },
  model: {
    prop: "templateIds",
    event: "ids-selected"
  },
  props: {
    templateIds: {
      type: Array,
      required: true
    },
    categoryId: {
      type: Number,
      default: 0
    },
    templates: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedIds: []
    };
  },
  computed: {
    filteredTemplates() {
      return this.categoryId
        ? this.templates.filter(i => i.category == this.categoryId)
        : this.templates;
    },
    filteredTemplatesIds() {
      return this.filteredTemplates.map(i => i.id);
    },
    isSelectedAll() {
      return (
        this.selectedIds.length === this.filteredTemplatesIds.length &&
        this.filteredTemplatesIds.every(id => this.selectedIds.includes(id))
      );
    }
  },
  watch: {
    categoryId() {
      this.selectedIds = [];
    },
    selectedIds(ids) {
      this.$emit("ids-selected", ids);
    }
  },
  created() {
    this.selectedIds = [...this.templateIds];
  },
  methods: {
    toggleItem(template) {
      const index = this.selectedIds.findIndex(id => id === template.id);
      if (index > -1) {
        this.selectedIds.splice(index, 1);
      } else {
        this.selectedIds.push(template.id);
      }
    },
    toggleAll() {
      this.selectedIds = !this.isSelectedAll
        ? [...this.filteredTemplatesIds]
        : [];
    },
    isSelected(template) {
      return this.selectedIds.some(id => id === template.id);
    }
  }
};
</script>

<style lang="scss" scoped>
.templates {
  &__list {
    position: relative;
  }

  &__list-item {
    display: flex;
    align-items: center;

    &:not(:last-of-type) {
      margin-bottom: $spacing * 2;
    }

    ::v-deep .v-input--selection-controls {
      margin-top: 0;
    }
  }

  &__text {
    padding: $spacing * 1.75 $spacing * 3.75;
    background: $base-light;
    color: $dark-blue-3;
    border-radius: 20px;
    white-space: pre-line;
    flex: 1;
    user-select: none;
    cursor: pointer;
  }

  &__select-all {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    background: $light;
    z-index: 1;
  }

  &__no-data {
    padding: $spacing * 4 $spacing * 2;
    background-color: $light-4;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 25px;
    color: $dark-blue-3;
    text-align: center;
  }
}
</style>
